(ns ycweb.app.website.dlp.widgets.promobanner
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc promo-banner < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:promo-banner/keys
         [title subtitle button-icon show-label?
          background-colour logo-public-id logo-alt url
          show-content? button-text link-type spacer-size
          use-date-range? spacer]} properties

        dark-background? (not (:background-colour/text-dark? background-colour))]

    [:<>
     (when
       (and
         show-content?
         (or url button-text))
       [:aside.yc-section
        [:a.text-banner.u-max-width-720.u-text-white
         (merge
           (when (= link-type "onpage")
             (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace url #"\#" ""))))
           {:href url
            :class (str "u-bg-" (:background-colour/colour-name background-colour))})
         [:div.text-banner__title-wrapper
          (cond
            (u/presence logo-public-id)
            (web-common/lazy-image app-atom
              logo-public-id
              {:class ["text-banner__logo"]}
              {:alt (or logo-alt (str title " logo"))})

            :else
            [:h2.text-banner__title
             {:class (when-not dark-background? "u-text-oil")}
             [:b title]
             (when (u/presence subtitle)
               [:span.text-banner__subtitle
                subtitle])])]

         [:div.text-banner__button-wrapper
          (buttons/button-web button-text
            {:style (if dark-background? :secondary :primary)
             :full true
             :icon button-icon})]
         (when (and show-label? logo-public-id)
           [:div.text-banner__label
            [:span
             {:class "text-pill  text-pill--tiny  text-pill--dark"}
             "Featured brand:"]])]
        (when (and use-date-range? spacer)
          [:div
           {:class (str "dlp-spacer dlp-spacer--" spacer-size)}])])]))